import type { Profile } from 'models';
import { useMemo } from 'react';

export const useEmailNotificationSettings = ({ viewer }: { viewer: Profile }) =>
  useMemo(
    () => ({
      enableNotifications: viewer.emailNotificationsSettings.enableNotifications?.value ?? false,
      events: viewer.emailNotificationsSettings.events?.value ?? false,
      giving: viewer.emailNotificationsSettings.giving?.value ?? false,
      newsfeed: viewer.emailNotificationsSettings.newsfeed?.value ?? false,
      program: viewer.emailNotificationsSettings.program?.value ?? false,
    }),
    [
      viewer.emailNotificationsSettings.enableNotifications?.value,
      viewer.emailNotificationsSettings.events?.value,
      viewer.emailNotificationsSettings.giving?.value,
      viewer.emailNotificationsSettings.newsfeed?.value,
      viewer.emailNotificationsSettings.program?.value,
    ],
  );
